import { TagProps } from '~/components/Abstracts/Tag'

export default function serializeTag({ label }): TagProps {
  return {
    label: label,
  }
}
